import Container from "react-bootstrap/Container";
import RetailLeadForm from "../../calculators/retailLeadForm";
import { Row, Col, Card } from "react-bootstrap";
import Faq from "../../components/Faq";
import "../../styles/dualEducation.css";
import "../../styles/sliderCalculator.css";

export default function SzemelyiKolcson() {
  return (
    <>
      <Container className="px-1 hero mx-md-auto">
        <Row className="align-items-center g-4 g-lg-5">
          <Col md={7} className="order-2 order-md-1">
            {/* <span className="badge">SZEMÉLYI KÖLCSÖN • ÖSSZEHASONLÍTÁS • 2026</span> */}

            <h1 className="title">
              Személyi kölcsön <br />
              <span style={{ color: "#c7d2fe" }}>kalkulátor</span>
            </h1>

            <p className="subtitle">
              A személyi kölcsön szabad felhasználású hitel, amelyet fedezet
              nélkül, jellemzően 300 000-10 000 000 forint között, 6-84 hónapos
              futamidőre nyújtanak a magyar bankok; a THM 2026-ban a
              hitelösszegtől, futamidőtől és az ügyfél KHR-hiteltörténetétől
              függően nagyjából 9-25% között mozog.
              <br />
              <span className="fw-bold">
                Számold ki a várható havi törlesztőt, és kérj személyre szabott
                ajánlatot!
              </span>
            </p>
          </Col>

          <Col md={5} className="order-1 order-md-2">
            <RetailLeadForm leadType="Personal_loan" />
          </Col>
        </Row>
      </Container>

      <Container>
        <section className="section">
          <Row className="g-4">
            <Col md={4}>
              <Card className="card">
                <div className="kpi">9-25%</div>
                <div className="muted">Illusztratív THM tartomány</div>
              </Card>
            </Col>

            <Col md={4}>
              <Card className="card">
                <div className="kpi">300e-10M Ft</div>
                <div className="muted">Igényelhető hitelösszeg</div>
              </Card>
            </Col>

            <Col md={4}>
              <Card className="card">
                <div className="kpi">1-3 nap</div>
                <div className="muted">Jellemző bírálati idő</div>
              </Card>
            </Col>
          </Row>
        </section>

        <section id="folyamat" className="section">
          <h2 className="h2">Így működik a személyi kölcsön igénylése</h2>
          <div className="steps-container mt-4">
            <Row className="g-4">
              <Col md={3} xs={12} className="text-center">
                <div className="step-number">1</div>
                <p className="fw-bold">Adatok megadása</p>
                <p className="small">
                  Hitelösszeg, futamidő, opcionálisan jövedelem
                </p>
              </Col>
              <Col md={3} xs={12} className="text-center">
                <div className="step-number">2</div>
                <p className="fw-bold">Becslés megtekintése</p>
                <p className="small">
                  Azonnal látod az illusztratív havi törlesztőt
                </p>
              </Col>
              <Col md={3} xs={12} className="text-center">
                <div className="step-number">3</div>
                <p className="fw-bold">Ajánlatkérés</p>
                <p className="small">
                  Elérhetőséged megadása, továbbítjuk a kiválasztott bankoknak
                </p>
              </Col>
              <Col md={3} xs={12} className="text-center">
                <div className="step-number">4</div>
                <p className="fw-bold">Összehasonlítás és döntés</p>
                <p className="small">
                  A beérkező ajánlatok közül te döntesz, kötelezettség nélkül
                </p>
              </Col>
            </Row>
          </div>
        </section>

        <section id="faq" className="section pb-0">
          <h2 className="h2">Gyakran ismételt kérdések</h2>

          <Faq
            categories={[
              {
                key: "altalanos",
                label: "Általános",
                items: [
                  {
                    question:
                      "Mi számít jó THM-nek személyi kölcsönnél 2026-ban?",
                    answer:
                      "2026-ban egy 1-3 millió forintos, 36 hónapos személyi kölcsönnél a 10-15% közötti THM tekinthető versenyképesnek jó hiteltörténet mellett; 18% felett érdemes más bankok ajánlatát is megnézni. A THM mindig tartalmazza a kamatot és a legtöbb díjat is, ezért ez az elsődleges összehasonlítási alap, nem a hirdetett kamat.",
                  },
                  {
                    question: "Felvehetek személyi kölcsönt KHR-bejegyzéssel?",
                    answer:
                      "Aktív, negatív (B) KHR-listás státusszal a legtöbb hazai bank elutasítja a hiteligénylést, mivel a KHR-ellenőrzés kötelező eleme a bírálatnak. Lezárt, passzív KHR-bejegyzés esetén egyes bankok és pénzügyi vállalkozások továbbra is mérlegelik a kérelmet, magasabb kamat vagy alacsonyabb hitelösszeg mellett.",
                  },
                  {
                    question:
                      "Mennyi idő alatt bírálják el a személyi kölcsön kérelmet?",
                    answer:
                      "A legtöbb banknál a teljes online igénylési folyamat, a dokumentumfeltöltéstől a szerződéskötésig, 1-3 munkanapot vesz igénybe, hiánytalan papírok esetén. A folyósítás jellemzően a szerződés aláírását követő 1-2 munkanapon belül megtörténik, banki munkarendtől függően.",
                  },
                  {
                    question:
                      "Van különbség a szabad felhasználású és a hitelkiváltó kölcsön THM-je között?",
                    answer:
                      "Igen: a hitelkiváltó (más hitel kiváltására szánt) személyi kölcsönök THM-je jellemzően 1-3 százalékponttal alacsonyabb, mert a bank kockázata alacsonyabb, és sok intézmény kedvezményt ad a meglévő hitel kiváltására. Szabad felhasználásnál nincs ilyen automatikus kedvezmény.",
                  },
                  {
                    question:
                      "Milyen dokumentumok kellenek a személyi kölcsön igényléséhez?",
                    answer:
                      "Személyazonosító igazolvány, lakcímkártya és adókártya mellett jövedelemigazolás szükséges (munkáltatói igazolás vagy 3-6 havi bankszámlakivonat), valamint a bank saját igénylőlapja. Meglévő hitel kiváltásához a futó szerződés és az aktuális egyenlegigazolás is szükséges.",
                  },
                ],
              },
            ]}
          />

          <p className="small mt-4">
            A fenti kalkulátor illusztratív becslést ad, nem minősül
            hitelbírálatnak vagy ajánlattételnek. A Financials.hu nem
            hitelintézet; a végleges kondíciókat a kiválasztott bank
            hitelbírálata határozza meg. Az oldalon feltüntetett THM-tartományok
            forrása a bankok hivatalos hirdetménye és az MNB nyilvános
            adatbázisa.
          </p>
        </section>
      </Container>
    </>
  );
}
